import api from '@/utils/api'

// scope: { seasonId, leagueId } for the playoffs of a league, { seasonId, cup: true, cupLeagueId } for a cup
function query({ seasonId, leagueId, cup, cupLeagueId }) {
    const params = [`seasonId=${seasonId}`]
    if (cup) params.push('cup=true')
    if (leagueId && !cup) params.push(`leagueId=${leagueId}`)
    if (cupLeagueId) params.push(`cupLeagueId=${cupLeagueId}`)
    return params.join('&')
}

export default {
    getBracket(scope) {
        return api.get(`brackets?${query(scope)}`)
    },

    saveBracket(data) {
        return api.put('brackets', data)
    },

    deleteBracket(id) {
        return api.delete(`brackets/${id}`)
    },

    // the bracket being edited, filled in from the standings and the results (not saved)
    previewBracket(data) {
        return api.post('brackets/preview', data)
    }
}
